import React from 'react';
import { ReactComponent as SpinnerIcon } from '@/assets/icons/spinner.svg';
import { ReactComponent as SpinnerThickIcon } from '@/assets/icons/spinner-thick.svg';

import { SpinnerContainer } from './styles';

interface SpinnerProps extends React.PropsWithChildren {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  type?: 'thin' | 'thick';
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 16,
  className,
  style,
  children,
  type = 'thin',
}) => {
  return (
    <SpinnerContainer className={className} style={style}>
      {type === 'thin' ? (
        <SpinnerIcon width={size} height={size} />
      ) : (
        <SpinnerThickIcon width={size} height={size} />
      )}
      {children}
    </SpinnerContainer>
  );
};

export default Spinner;
